import { resToCategory } from "services/categories";
import { resToImage } from "services/images";

import { Recipe } from "./types";

export const resToRecipe = (res: any): Recipe => {
  return {
    id: res.id,
    title: res.title ? res.title : "",
    metaDescription: res.metaDescription ?? "",
    cookingTime: res.cookingTime ?? "",
    metaTitle: res.metaTitle ?? "",
    numberOfPeople: res.numberOfPeople ?? 0,
    slug: res.slug ?? "",
    content: res.content ?? "",
    ingredients: res.ingredients ?? "",
    category: res.category ? resToCategory(res.category) : null,
    image: res.image ? resToImage(res.image) : null,
    published: res.published ?? false,
    createdAt: res.createdAt ? new Date(res.createdAt) : new Date(),
    updatedAt: res.updatedAt ? new Date(res.updatedAt) : new Date(),
  };
};

export const recipeToBody = (data: Recipe): any => ({
  title: data.title,
  metaDescription: data.metaDescription,
  cookingTime: data.cookingTime,
  metaTitle: data.metaTitle,
  numberOfPeople: data.numberOfPeople,
  slug: data.slug,
  content: data.content,
  ingredients: data.ingredients,
  categoryId: data.category?.id,
  imageId: data.image?.id,
});
